import type { FunctionComponent } from "react";
import SWReactTableWrapper from "app/components/React/Table/SWReactTableWrapper";
import { swSettings } from "app/common/services/swSettings";
import { useCurrentStateAndParams } from "@uirouter/react";
import { MonetizationNetworksTableTop } from "./MonetizationNetworksTableTop";
import { apiHelper } from "app/common/services/apiHelper";
import queryString from "query-string";
import {
    MonetizationNetworksCompareTableSettings,
    MonetizationNetworksSingleTableSettings,
} from "./MonetizationNetworksTableSettings";
import { MonetizationNetworksTableContainer } from "./StyledComponents";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const MonetizationNetworksTable: FunctionComponent<any> = () => {
    const { params } = useCurrentStateAndParams();
    const { AdNetwork_filters: filters } = params;
    const downloadExcelPermitted = swSettings.current.resources.IsExcelAllowed;
    const pageSize = 100;
    const searchFilter = "name;contains;";
    const index = filters ? filters.indexOf(searchFilter) : -1;
    const searchTerm = index >= 0 ? filters.slice(index + searchFilter.length).split(",")[0] : "";

    const getApiEndpoint = () => {
        return "api/websiteanalysis/GetTrafficDisplayPaidOutgoingAdsTable";
    };
    const getInitialFilters = () => {
        const initialParams = { ...params };
        const isCompare = initialParams.key.split(",").length > 1;
        const filters = [];
        if (initialParams.AdNetwork_filters) {
            filters.push(`name;contains;"${searchTerm}"`);
            delete initialParams.AdNetwork_filters;
        }
        if (filters.length > 0) {
            initialParams.filter = filters.join(",");
        }
        if (!initialParams.AdNetwork_orderby) {
            initialParams.orderby = isCompare ? "TotalShare desc" : "Share desc";
        } else {
            initialParams.orderby = initialParams.AdNetwork_orderby;
            delete initialParams.AdNetwork_orderby;
        }
        return apiHelper.transformParamsForAPI(initialParams);
    };

    const getColumns = () => {
        const { AdNetwork_orderby: orderby, key } = params;
        const mode = key.split(",").length > 1 ? "compare" : "single";
        let sortedColumn;
        if (orderby) {
            const [field, sortDirection] = orderby.split(" ");
            sortedColumn = {
                field,
                sortDirection,
            };
        }
        return mode === "single"
            ? MonetizationNetworksSingleTableSettings.getColumns(sortedColumn)
            : MonetizationNetworksCompareTableSettings.getColumns(sortedColumn);
    };
    const getExcel = () => {
        const params = getInitialFilters();
        const queryStringParams = queryString.stringify(params);
        return `/export/analysis/GetTrafficDisplayPaidOutgoingAdsTsv?${queryStringParams}`;
    };
    const onSort = ({ field, sortDirection }) => {
        proNavigator.applyUpdateParams({
            // eslint-disable-next-line @typescript-eslint/naming-convention
            AdNetwork_orderby: `${field} ${sortDirection}`,
        });
    };
    const dataParamsAdapter = (params) => {
        const transformedParams = { ...params };
        if (transformedParams.sort) {
            transformedParams.orderby = `${transformedParams.sort} ${transformedParams.asc ? "asc" : "desc"}`;
            delete transformedParams.sort;
            delete transformedParams.asc;
        }
        return transformedParams;
    };
    return (
        <MonetizationNetworksTableContainer data-automation="monetization-networks-table-container">
            <div data-automation="monetization-networks-table">
                <SWReactTableWrapper
                    initialFilters={getInitialFilters()}
                    tableColumns={getColumns()}
                    tableOptions={{
                        metric: "outgoingAdsAdvertisersTable",
                    }}
                    serverApi={getApiEndpoint()}
                    dataParamsAdapter={dataParamsAdapter}
                    recordsField="Records"
                    totalCountProperty="TotalCount"
                    totalRecordsField="TotalCount"
                    onSort={onSort}
                    fetchServerPages={1}
                    rowsPerPage={pageSize}
                    pageIndent={1}
                >
                    {(topComponentProps) => (
                        <MonetizationNetworksTableTop
                            {...topComponentProps}
                            searchTerm={searchTerm}
                            excelLink={getExcel()}
                            downloadExcelPermitted={downloadExcelPermitted}
                        />
                    )}
                </SWReactTableWrapper>
            </div>
        </MonetizationNetworksTableContainer>
    );
};
